module.exports = __webpack_public_path__ + "plaque-nomogram-male.56fe4b313c3b828f95e634d99d9db491.png";